import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { NotifierComponent } from '../../shared/components/notifier/notifier.component';
import { NotifierInterface } from '../interfaces/notifier.interface';

@Injectable({
  providedIn: 'root',
})
export class NotifierService {
  public refSnackBar!: MatSnackBarRef<NotifierComponent>;
  constructor(private snackBar: MatSnackBar) {}

  showNotification({ messageType, horizontalPosition, verticalPosition, ...data }: NotifierInterface) {
    let config: object = {
      data,
      duration: data.duration ?? 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
    };
    if (messageType) config = { ...config, panelClass: [messageType] };
    this.refSnackBar =  this.snackBar.openFromComponent(NotifierComponent, config);
  }

  dimiss() {
    this.snackBar.dismiss();
  }
}
